import { render } from "./Resultados.vue?vue&type=template&id=4fdbbae6"
import script from "./Resultados.vue?vue&type=script&lang=js"
export * from "./Resultados.vue?vue&type=script&lang=js"
script.render = render

export default script